import React, { Fragment } from 'react';

import { subscriber_profile_path } from '@routes';
import { PaginationType } from '@utils/backend-api/subscriber_directory';
import { POST_TYPE_ARTICLES } from '@utils/constants';

import NoResultsMessage from '../NoResultsMessage';
import Pagination from '../Pagination';
import ArticleOrBriefingFeedItem, { ArticleOrBriefing } from './ArticleOrBriefingFeedItem';

export default function Feed({
  articlesOrBriefings,
  offerCode,
  paginationData,
  username,
}: {
  articlesOrBriefings: ArticleOrBriefing[];
  offerCode?: string;
  paginationData?: PaginationType;
  username?: string;
}) {
  const getPath = (page: number) =>
    subscriber_profile_path(username, POST_TYPE_ARTICLES, page === 1 ? undefined : page);

  return (
    <Fragment>
      {articlesOrBriefings?.length > 0 ? (
        <Fragment>
          {articlesOrBriefings.map((articleOrBriefing) => (
            <Fragment key={`${articleOrBriefing.type}-${articleOrBriefing.id}`}>
              <ArticleOrBriefingFeedItem
                articleOrBriefing={articleOrBriefing}
                offerCode={offerCode}
              />
            </Fragment>
          ))}
        </Fragment>
      ) : (
        <NoResultsMessage />
      )}
      {paginationData?.totalPages > 1 && (
        <Pagination paginationData={paginationData} getPath={getPath} />
      )}
    </Fragment>
  );
}
